import React from "react";
import Project from "../Components/Project";
import { certificationDetails } from "../Details";

/* Professional hover style for page heading */
const sectionHeadingClass = `
  relative inline-block
  transition-all duration-300
  hover:text-purple-400
  after:absolute after:left-0 after:-bottom-2
  after:h-[3px] after:w-0 after:bg-purple-500
  after:transition-all after:duration-300
  hover:after:w-full
`;

function Projects() {
  return (
    <main className="container mx-auto max-width pt-10 pb-20">
      
      {/* PAGE HEADER */}
      <section>
        <h1
          className={`text-2xl text-white 
                      md:text-4xl xl:text-5xl font-bold ${sectionHeadingClass}`}
        >
          Certifications
        </h1>

        <p className="text-white/70 py-2 lg:max-w-3xl">
          Industry-recognized cloud and DevOps certifications validating
          expertise across AWS and Google Cloud platforms.
        </p>
      </section>

      {/* CERTIFICATION GRID */}
      <section
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 
                   gap-8 pt-10"
      >
        {certificationDetails.map((cert) => (
          <Project
            key={cert.title}
            title={cert.title}
            issuer={cert.issuer}
            image={cert.image}
            credentialLink={cert.credentialLink}
          />
        ))}
      </section>
    </main>
  );
}

export default Projects;
